import Vue from 'vue'
import Router from 'vue-router'
import ExtractTransaction from '@/views/Wallet/ExtractTransaction.vue'
import WithdrawOptions from '@/views/Wallet/WithdrawOptions.vue'
import RegisterPixKey from '@/views/Wallet/RegisterPixKey.vue'
import RegisterPixKeyChooseOwner from '@/views/Wallet/RegisterPixKeyChooseOwner.vue'
import RegisterPixKeyValidation from '@/views/Wallet/RegisterPixKeyValidation.vue'
import KeyPixValidationEmail from '@/views/Wallet/KeyPixValidationEmail.vue'
import BrCodeCopiedSuccessful from '@/views/Wallet/BrCodeCopiedSuccessful.vue'
import WithdrawPix from '@/views/Wallet/WithdrawPix.vue'
import WalletPending from '@/views/Wallet/WalletPending.vue'
import Receipt from '@/views/Wallet/Receipt.vue'
import Wallet from '@/views/Wallet/Wallet.vue'
import DepositMoney from '@/views/Wallet/DepositMoney.vue'

import ShoppingConfirmPassword from '@/views/Shopping/ShoppingConfirmPassword.vue'
import TypeFormShopping from '@/views/Shopping/TypeformShopping.vue'

import Invites from '@/views/Stationery/Invites.vue'
import InvitesLayouts from '@/views/Stationery/InvitesLayouts.vue'
import InvitesEdit from '@/views/Stationery/InvitesEdit.vue'

import RsvpGuests from '@/views/Rsvp/RsvpGuests.vue'
import RsvpConfig from '@/views/Rsvp/RsvpConfig.vue'
import RsvpInvites from '@/views/Rsvp/RsvpInvites.vue'
import RsvpInviteForm from '@/views/Rsvp/RsvpInviteForm.vue'
import RsvpAssessoria from '@/views/Rsvp/RsvpAssessoria.vue'

import OnboardingSteps from '@/views/Onboarding/OnboardingSteps.vue'
import OnboardingError from '@/views/Onboarding/OnboardingError.vue'

import VerifyDomainAvailability from '@/views/Domain/VerifyDomainAvailability.vue'
import GiftsDashboard from '@/views/GiftsList/GiftsDashboard.vue'
import ThemeCustomization from '@/views/ThemeCustomization/ThemeCustomization'
import DeactivateShoppingPage from '@/views/DeactivateShopping/DeactivateShoppingPage'
import TaxBackLP from '@/views/Campaigns/TaxBackLP.vue'

import countVisitWalletMiddleware from '@/middlewares/countVisitWallet'
import InvitesData from '@/lib/invites/routersOfLayout'
import OnboardingData from '@/lib/onboarding/routers'
import { getActiveMenu } from './menu'
import stopRedirectIfThereChanges from '@/middlewares/stopRedirectIfThereChanges'
import startTimerTypeformGiftListFeedback from '@/middlewares/startTimerTypeformGiftListFeedback'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/dominio',
      name: 'dominio',
      component: VerifyDomainAvailability,
    },
    {
      path: '/presentes/:tab',
      name: 'presentes',
      component: GiftsDashboard,
      beforeEnter: (to, from, next) => {
        startTimerTypeformGiftListFeedback()
        return next()
      },
    },
    {
      path: '/presentes',
      name: 'presentes-index',
      component: GiftsDashboard,
      beforeEnter: (to, from, next) => {
        startTimerTypeformGiftListFeedback()
        return next()
      },
    },
    {
      path: '/carteira',
      name: 'carteira',
      component: Wallet,
    },
    {
      path: '/carteira/saque-opcoes',
      name: 'carteira-saque',
      component: WithdrawOptions,
    },
    {
      path: '/carteira/escolher-conta',
      name: 'carteira-escolher-conta',
      component: RegisterPixKeyChooseOwner,
    },
    {
      path: '/carteira/cadastrar-pix',
      name: 'carteira-cadastro-pix',
      component: RegisterPixKey,
    },
    {
      path: '/carteira/cadastrar-pix/:pixType',
      name: 'carteira-cadastro-pix-por-tipo',
      component: RegisterPixKey,
    },
    {
      path: '/carteira/cadastro-chave-pix',
      name: 'carteira-validacao-pix',
      component: RegisterPixKeyValidation,
    },
    {
      path: '/carteira/verificacao-pix',
      name: 'pix-validacao-email',
      component: KeyPixValidationEmail,
    },
    {
      path: '/carteira/verificacao-pix/:id/:token',
      name: 'pix-validacao-email-path',
      component: KeyPixValidationEmail,
    },
    {
      path: '/carteira/brcode-copiado',
      name: 'pix-brcode-copied',
      component: BrCodeCopiedSuccessful,
    },
    {
      path: '/carteira/saque-pix',
      name: 'carteira-saque-pix',
      component: WithdrawPix,
    },
    {
      path: '/carteira/extrato',
      name: 'carteira-extrato',
      component: ExtractTransaction,
    },
    {
      path: '/carteira/indisponivel',
      name: 'carteira-indisponivel',
      component: WalletPending,
    },
    {
      path: '/carteira/recibo',
      name: 'carteira-recibo',
      component: Receipt,
    },
    {
      path: '/carteira/deposito',
      name: 'carteira-money',
      component: DepositMoney,
    },
    {
      path: '/carteira/shopping/confirmar-senha',
      name: 'shopping-confirmar-senha',
      component: ShoppingConfirmPassword,
    },
    {
      path: '/convites',
      name: 'convites',
      component: Invites,
    },
    {
      path: '/convites/:tipo',
      name: 'convites-layouts',
      component: InvitesLayouts,
      beforeEnter: (to, from, next) => {
        const tipo = InvitesData.find((save) => save.type === to.params.tipo)
        if (!tipo) return next({ path: '/convites' })
        else return next()
      },
    },
    {
      path: '/convites/:tipo/:modelo',
      name: 'convites-modelos',
      component: InvitesEdit,
      beforeEnter: (to, from, next) => {
        const type = InvitesData.find((save) => save.type === to.params.tipo)
        if (type) {
          let model = ''
          InvitesData.forEach((element) => {
            model = element['model'].find((save) => save === to.params.modelo)
          })
          if (!model) return next({ path: '/convites' })
          else return next()
        } else return next({ path: '/convites' })
      },
    },
    {
      path: '/rsvp',
      name: 'rsvp',
      component: RsvpGuests,
    },
    {
      path: '/rsvp/configuracoes',
      name: 'rsvp-configuracoes',
      component: RsvpConfig,
    },
    {
      path: '/rsvp/cadastrar-convites',
      name: 'rsvp-cadastrar-convites',
      component: RsvpInviteForm,
    },
    {
      path: '/rsvp/editar-convite/:inviteId',
      name: 'rsvp-editar-convite',
      component: RsvpInviteForm,
    },
    {
      path: '/rsvp-assessoria',
      name: 'rsvp-assessoria',
      component: RsvpAssessoria,
    },
    {
      path: '/rsvp-convites',
      name: 'rsvp-convites',
      component: RsvpInvites,
    },
    {
      path: '/rsvp*',
      name: 'others-rsvp',
      redirect: 'rsvp',
    },
    {
      path: '/carteira*',
      name: 'others-wallet',
      redirect: 'carteira',
    },
    {
      path: '/save-the-date*',
      name: 'others-save-the-date',
      redirect: 'save-the-date',
    },
    {
      path: '/onboarding',
      name: 'onboarding',
      redirect: '/onboarding/passo-1',
    },
    {
      path: '/onboarding/configurar-novamente',
      name: 'onboarding-error',
      component: OnboardingError,
    },
    {
      path: '/onboarding/:id',
      name: 'onboarding-steps',
      component: OnboardingSteps,
      beforeEnter: (to, from, next) => {
        const tipo = OnboardingData.find((save) => save.id === to.params.id)
        if (!tipo) return next({ path: '/onboarding/passo-1' })
        else return next()
      },
    },
    {
      path: '/customizacao-do-tema',
      name: 'customizacao-do-tema',
      component: ThemeCustomization,
    },
    {
      path: '/desativacao-shopping',
      name: 'desativacao-shopping',
      component: DeactivateShoppingPage,
    },
    {
      path: '/campanha/taxa-de-volta',
      name: 'taxa-de-volta',
      component: TaxBackLP,
    },
    {
      path: '/shopping*',
      name: 'shopping',
      redirect: '/desativacao-shopping',
    },
    {
      path: '/como-foi-sua-compra',
      name: 'typeform-shopping',
      component: TypeFormShopping,
    },
    {
      path: '/clean-cache',
      name: 'clean-cache',
      beforeEnter: (to, from, next) => {
        localStorage.clear()
        sessionStorage.clear()
        return next({ name: 'dominio' })
      },
    },
    {
      path: '*',
      name: 'others',
      redirect: 'dominio',
    },
  ],

  // eslint-disable-next-line no-unused-vars
  scrollBehavior(to, from, savedPosition) {
    return {
      x: 0,
      y: 0,
      behavior: 'smooth',
    }
  },
})

router.beforeEach((to, from, next) => {
  const go = to.query.go

  if (go && go === 'shopping') next({ path: '/desativacao-shopping' })
  else if (go) next({ name: go })

  if (stopRedirectIfThereChanges(to)) next(false)
  else next()
})

// eslint-disable-next-line no-unused-vars
router.afterEach((to, from) => {
  if (to.name == 'carteira') {
    countVisitWalletMiddleware()
  }

  // notify shared menu about active item
  let wait = 250
  if (from.path === '/') {
    wait = 1000
  }
  setTimeout(function () {
    const customEvent = new Event('SHAREDMENU_ACTIVE_ROUTE')
    customEvent.active = getActiveMenu(to.path)
    window.dispatchEvent(customEvent)
  }, wait)
})

export default router
